module.exports = __webpack_public_path__ + "static/media/tutorialArrow3.66276106.svg";